import { render, staticRenderFns } from "./HotDestinationsCityCard.vue?vue&type=template&id=59f4d27f&scoped=true"
import script from "./HotDestinationsCityCard.vue?vue&type=script&lang=js"
export * from "./HotDestinationsCityCard.vue?vue&type=script&lang=js"
import style0 from "./HotDestinationsCityCard.vue?vue&type=style&index=0&id=59f4d27f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4d27f",
  null
  
)

export default component.exports